import React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import styles from "./FloatingSidebar.module.scss";

const SidebarNavItem = ({
  item,
  isActive,
  isGroupExpanded,
  isCollapsed,
  onSelect,
}) => {
  if (!item) return null;

  const IconComponent = item.icon;
  if (!IconComponent) return null;

  const handleClick = () => {
    if (!onSelect) return;
    onSelect(item);
  };

  const itemClassName = [
    styles.navItem,
    isActive ? styles.navItemActive : "",
    isGroupExpanded ? styles.navItemGroupExpanded : "",
    isCollapsed ? styles.navItemCollapsed : "",
  ]
    .filter(Boolean)
    .join(" ");

  const button = (
    <ListItemButton selected={isActive} onClick={handleClick} className={itemClassName}>
      <ListItemIcon className={styles.navItemIcon}>
        <IconComponent />
      </ListItemIcon>
      {!isCollapsed && (
        <ListItemText
          primary={item.label}
          secondary={item.description}
          slotProps={{
            primary: { className: styles.navItemLabel },
            secondary: { className: styles.navItemDescription },
          }}
        />
      )}
    </ListItemButton>
  );

  if (!isCollapsed) return button;

  return (
    <Tooltip title={item.label} placement="right">
      {button}
    </Tooltip>
  );
};

export default SidebarNavItem;
